// Copyright (c) 2016 Deere & Company

import './labeled-form-input.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const LabeledFormInput = props => {

    const errors = props.fields.filter(field =>
        field && (field.touched || field.initialValue) && field.error
    );

    const displayClass = `form-group${props.className ? ` ${props.className}` : ''}${errors.length ? ' error' : ''}`;

    return (
        <div className={displayClass}>
            <label>
                {props.labelNeedsTranslation ?
                    <FormattedMessage id={props.label}/> :
                    <span>{props.label}</span>
                }
            </label>
            <div>
                {props.children}
            </div>
        </div>
    );

};

LabeledFormInput.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    fields: PropTypes.array,
    label: PropTypes.string.isRequired,
    labelNeedsTranslation: PropTypes.bool
};
LabeledFormInput.defaultProps = {
    fields: [],
    labelNeedsTranslation: true
};

export default LabeledFormInput;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-form-input.js